<template>
        <v-card>
          <v-card-title>
            Boxes
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            dense
            :loading="loading"
            loading-text="Loading... Please wait"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.IsOpen="{ item }">
              <div v-if="item.IsOpen">
                <v-chip class="mx-2" :color="item.Color" dark fab small @click="setSelectedEvent(item)">
                  <v-icon small>fa-lock-open</v-icon>
                </v-chip>
              </div>
              <div v-if="!item.IsOpen">
                <v-chip class="mx-2" :color="item.Color" dark fab small @click="setSelectedEvent(item)">
                  <v-icon small>fa-lock</v-icon>
                </v-chip>
              </div>
            </template>
            <template v-slot:item.Ant="{ item }">
              <div v-if="item.Ant>0">
              <v-chip dark hint="Checked in pilots" fab small :to="item.ToLsbLink" :color="item.Color">{{ item.Ant }}</v-chip>
              </div>
             </template>
             <template v-slot:item.AntPos="{ item }">
              <div v-if="item.AntPos>0">
              <v-chip dark hint="Pilots with position" fab small :to="item.ToMapBoxLink" :color="item.Color">{{ item.AntPos }}</v-chip>
              </div>
             </template>
          </v-data-table>
        </v-card>
</template>

<script>
// import axios from "axios";

export default {
    name: 'EventTable',
    props: {
        items: {
            type: Array
        },
        loading: Boolean
    },
  data() {
    return {
      e1: 1,
      search: "",
    //   loading: true,
      headers: [
        { text: "Box", value: "Event" },
        { text: "Description", value: "EventDescription" },
        { text: "Status", value: "IsOpen" },
        { text: "Activity", value: "Ant" },
        { text: "Positions", value: "AntPos" },
        { text: "", value: "Action" },
        { text: "Date", value: "Dato" },
        { text: "Time", value: "Tid" },
        { text: "By", value: "OpenedBy" },
        { text: "Mobile", value: "OpenedByMID" },
        { text: "Comment", value: "Comment" }
      ],
      lsblink: "/airbox/0"
     };
  },
  methods: {
    setSelectedEvent(item) {
      this.lsblink = '/airbox/' + item.EventId;
      // this.router.push(this.lsblink);
    }
  }
};
</script>